// ─── Public Status Page — the incident history ───────────────────────
//
// Already filtered and sorted by App.tsx (pinned first, then newest occurredAt),
// so this is a map plus the two empty states. They are NOT interchangeable: "no
// incidents in the period" is good news and should read like it, while "nothing
// matches your filters" is a dead end the visitor can undo — `filtered` picks
// between them.

import { da } from '../i18n/da';
import type { IncidentListProps } from '../types';
import { SIcon } from '../ui/SIcon';
import { IncidentCard } from './IncidentCard';

export function IncidentList({ incidents, filtered, onOpenIncident, hrefForIncident }: IncidentListProps) {
  if (incidents.length === 0) {
    return (
      <div className="sp-card sp-card-pad sp-empty">
        <SIcon name={filtered ? 'search' : 'operational'} size={24} />
        <p>{filtered ? da.incidentsNoMatch : da.incidentsEmpty}</p>
      </div>
    );
  }

  return (
    <div className="sp-incidents">
      {incidents.map((incident) => (
        <IncidentCard
          key={incident.id}
          incident={incident}
          href={hrefForIncident(incident)}
          onOpen={onOpenIncident}
        />
      ))}
    </div>
  );
}
